module.exports = __webpack_public_path__ + "img/Concierge.4fdb1cb2.png";